import React from "react";
import { Route } from "react-router-dom";


const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
	...rest
}) => (
		<Route
			{...rest}
			render={props => {

				/*if (isAuthProtected && azureB2cAuth.selectAccount() == null) {
					return (
						<Redirect to={{ pathname: '/login', state: { from: props.location } }} />
						)
				}*/

				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			}}
		/>
	);

export default AppRoute;

